import React from "react";

import { USER_ACTIONS } from "Bands/types";
import { DeleteUserEntityModal } from "Bands/containers";
import { copy } from "shared/assets";
import { useDispatch } from "react-redux";
import { deleteUserVehicle } from "Bands/state";

const { userVehicle: vehicleCopy } = copy;

interface Props {
  id: string;
  handleClose: () => void;
}

export const DeleteUserVehicleModal: React.FC<Props> = ({ id, handleClose }) => {
  const dispatch = useDispatch();

  const handleDelete = () => {
    dispatch(deleteUserVehicle(id));
  };

  return (
    <DeleteUserEntityModal
      type="vehicle"
      action={USER_ACTIONS.deleteUserVehicle}
      successMessage={vehicleCopy.messages.deleted}
      handleDelete={handleDelete}
      handleClose={handleClose}
    />
  );
};
